import { getLocale } from "../runtime";

const da_curatedby = /** @type {(inputs: {name: NonNullable<unknown>}) => string} */ (inputs) => {
	return `Udvalgt af ${inputs.name}`
};

const en_curatedby = /** @type {(inputs: {name: NonNullable<unknown>}) => string} */ (inputs) => {
	return `Curated by ${inputs.name}`
};

const es_curatedby = /** @type {(inputs: {name: NonNullable<unknown>}) => string} */ (inputs) => {
	return `Seleccionado por ${inputs.name}`
};

const fi_curatedby = /** @type {(inputs: {name: NonNullable<unknown>}) => string} */ (inputs) => {
	return `Kuratoija ${inputs.name}`
};

const nb_curatedby = /** @type {(inputs: {name: NonNullable<unknown>}) => string} */ (inputs) => {
	return `Utvalgt av ${inputs.name}`
};

const sv_curatedby = /** @type {(inputs: {name: NonNullable<unknown>}) => string} */ (inputs) => {
	return `Utvalt av ${inputs.name}`
};

const curatedby = /** @type {(inputs: {name: NonNullable<unknown>}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "da") return da_curatedby(inputs)
	if (locale === "en") return en_curatedby(inputs)
	if (locale === "es") return es_curatedby(inputs)
	if (locale === "fi") return fi_curatedby(inputs)
	if (locale === "nb") return nb_curatedby(inputs)
	if (locale === "sv") return sv_curatedby(inputs)
	return "curatedBy";
};

export { curatedby as "curatedBy" };